import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import WorkspaceService from "@core-ui/ContextServices/Workspace";
import { getClientServerUrl } from "@ext/enterprise/utils/availableCatalogsServer";
import { useEffect } from "react";
import { useAvailableCatalogsStore } from "./availableCatalogsStore";

/** Returns whether the available catalogs are still on their way, so the page can hold back what they may replace. */
export const useLoadAvailableCatalogs = (): boolean => {
	const { enterpriseCloud } = PageDataContextService.value.conf;
	const hasServer = Boolean(getClientServerUrl(enterpriseCloud, WorkspaceService.current()?.enterprise?.gesUrl));
	const apiUrlCreator = ApiUrlCreatorService.value;
	const load = useAvailableCatalogsStore((state) => state.load);
	const status = useAvailableCatalogsStore((state) => state.status);

	useEffect(() => {
		if (hasServer) void load(apiUrlCreator);
	}, [hasServer, load]);

	return hasServer && (status === "idle" || status === "loading");
};
